import script from "./HistoricalMaterialItemForm.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoricalMaterialItemForm.vue?vue&type=script&setup=true&lang=js"

import "./HistoricalMaterialItemForm.vue?vue&type=style&index=0&id=6a443d8f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a443d8f"]])

export default __exports__